import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/Reporte/reporteCostoVenta';
import ReporteCostoVenta from './ReporteCostoVenta';

const mstp = state => {
    return {
        ...state.reporteCostoVenta,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteCostoVenta)
